import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { maxUint256 } from "viem";
import ABIPEPE from "../../utils/pepeAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";

const useApprovePepe = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const approvePepe = useCallback(
    async () => {
      if (!isConnected || !account) {
        throw new Error("WALLET_NOT_CONNECTED");
      }

      try {
        const hash = await writeContractAsync({
          address: Environment.pepe,
          abi: ABIPEPE,
          functionName: "approve",
          args: [Environment.presaleContract, maxUint256],
        });

        console.log("Approval tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("Approval confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("Approval failed:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { approvePepe };
};

export default useApprovePepe;
